import { render, staticRenderFns } from "./TheUserForm.vue?vue&type=template&id=99882990&scoped=true&"
import script from "./TheUserForm.vue?vue&type=script&lang=js&"
export * from "./TheUserForm.vue?vue&type=script&lang=js&"
import style0 from "./TheUserForm.vue?vue&type=style&index=0&id=99882990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99882990",
  null
  
)

export default component.exports